/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable dot-notation */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-unused-state */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import React, { Component } from 'react';

import Aux from '../../../../../hoc/Aux';
import Classes from './ConfigurationScreenContentGenresItem.css';

class ConfigurationScreenContentGenresItem extends Component {
  render() {
    return (
      <Aux>
        <div className={`row ${Classes.CardContainerItem}`}>
          <div className="col-2 align-self-center">
            <img src={this.props.picture_small} className={Classes.PictureUser} title="img" alt="img" />
          </div>
          <div className="col-8 align-self-center">
            <p className={Classes.SongText}>
              <b>{this.props.name}</b>
            </p>
          </div>
          <div className="col-2 align-self-center">
            <i className={`${Classes.IcPlay} fas fa-trash-alt`} onClick={() => this.props.onRemove(this.props.fullGenre)} title="Remove the genre" />      
          </div>
        </div>
      </Aux>
    );
  }
} 

export default ConfigurationScreenContentGenresItem;
